import { render, staticRenderFns } from "./PiInvestmentFiles.vue?vue&type=template&id=119193ac"
import script from "./PiInvestmentFiles.vue?vue&type=script&lang=js"
export * from "./PiInvestmentFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports